const singletonId = Symbol();
const singletonEnforcer = Symbol();

class SingletonLoading {
  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) {
      throw new Error('SingletonLoading can not use construct.');
    }

    this.loadingBar = null;

    this._isLoading = false;
  }

  static getInstance() {
    if (!this[singletonId]) this[singletonId] = new SingletonLoading(singletonEnforcer);
    return this[singletonId];
  }

  setLoadingBar(element) {
    this.loadingBar = $(element);

    return this;
  }

  start() {
    const _ = this;

    _.loadingBar.show();

    _._isLoading = true;

    console.log('loading start');

    return _;
  }

  end() {
    const _ = this;

    _.loadingBar.hide();

    _._isLoading = false;

    console.log('loading end');

    return _;
  }

  get isLoading() {
    return this._isLoading;
  }
}

export default SingletonLoading;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/utils/SingletonLoading.js